import React from 'react';
import { Icon } from '../Icon/Icon.js';
const styles = {"inlineError":"InlineError-module__inlineError__4t24k"};
/** A field's error message with the alert icon (Foundations · TextField board, frames C2 and D4). */
export function InlineError({ message, id }) {
    return (React.createElement("span", { className: styles.inlineError, id: id },
        React.createElement(Icon, { name: "alert", size: 16 }),
        message));
}
//# sourceMappingURL=InlineError.js.map